import { navigateToChangeImpact } from '../../../links/index.jsx';

export const resetFilters = () => {
  const query = {
    title: null,
    startDate: null,
    endDate: null,
    peopleImpacted: null,
    changeImpactTypeIds: [],
    scale: [],
    perceptions: [],
    ownerIds: [],
    impactedEmployeesIds: [],
    impactedGroupsIds: [],
    impactedExternalEntitiesIds: [],
    actionPlanTypes: [],
    actionPlanStatuses: [],
    externalEntities: [],
    organizationStakeholderIds: [],
    taskIds: [],
    taskStatuses: [],
    taskOwnerIds: [],
    projectsIds: [],
  };

  navigateToChangeImpact(query);
};
